export const reportConstants = {
  WORKJOURNEY_FETCH_REQUEST: 'WORKJOURNEY_FETCH_REQUEST',
  WORKJOURNEY_FETCH_SUCCESS: 'WORKJOURNEY_FETCH_SUCCESS',
  WORKJOURNEY_FETCH_FAILURE: 'WORKJOURNEY_FETCH_FAILURE',
  INTEGRATIONLOG_FETCH_REQUEST: 'INTEGRATIONLOG_FETCH_REQUEST',
  INTEGRATIONLOG_FETCH_SUCCESS: 'INTEGRATIONLOG_FETCH_SUCCESS',
  INTEGRATIONLOG_FETCH_FAILURE: 'INTEGRATIONLOG_FETCH_FAILURE',
  NOTIFICATION_FETCH_REQUEST: 'NOTIFICATION_FETCH_REQUEST',
  NOTIFICATION_FETCH_SUCCESS: 'NOTIFICATION_FETCH_SUCCESS',
  NOTIFICATION_FETCH_FAILURE: 'NOTIFICATION_FETCH_FAILURE',
  REPROCESS_REQUEST: 'WORKJOURNEY_REPROCESS_REQUEST',
  REPROCESS_SUCCESS: 'WORKJOURNEY_REPROCESS_SUCCESS',
  REPROCESS_FAILURE: 'WORKJOURNEY_REPROCESS_FAILURE',
  LASTCONTACT_FETCH_REQUEST: 'LASTCONTACT_FETCH_REQUEST',
  LASTCONTACT_FETCH_SUCCESS: 'LASTCONTACT_FETCH_SUCCESS',
  LASTCONTACT_FETCH_FAILURE: 'LASTCONTACT_FETCH_FAILURE',
  ACCESS_FETCH_REQUEST: 'ACCESS_FETCH_REQUEST',
  ACCESS_FETCH_SUCCESS: 'ACCESS_FETCH_SUCCESS',
  ACCESS_FETCH_FAILURE: 'ACCESS_FETCH_FAILURE',
};
